import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-backdrop": "static",
  role: "dialog",
  ref: "modalElement"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header d-md-none ps-3 pe-3 pt-5 pb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left fs-2 pe-4 p-1" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "m-auto" }
const _hoisted_7 = {
  class: "d-flex",
  style: {"flex":"1"}
}
const _hoisted_8 = ["element-loading-text"]
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = {
  key: 0,
  class: "text-center pt-15"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`modal-dialog modal-dialog-centered modal-fullscreen-sm-down ${_ctx.size}`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "cursor-pointer",
            style: {"flex":"1"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleClosed && _ctx.toggleClosed(...args)))
          }, _hoisted_5),
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "header-button")
          ])
        ]),
        (_ctx.hasToolbar)
          ? _renderSlot(_ctx.$slots, "toolbar", { key: 0 })
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          "element-loading-text": _ctx.loadingText,
          class: _normalizeClass(`modal-body d-flex flex-column d-md-block ${_ctx.modalBodyClasses}`)
        }, [
          _createElementVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "body")
          ]),
          (_ctx.hasFooter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_8)), [
          [_directive_loading, _ctx.isLoading]
        ])
      ])
    ], 2)
  ], 512))
}